import type { RailLayout } from "@/data/rail-branches";
import type { LocationRun } from "../LocationRun/runs";
import type { LocationBoxPlacement } from "./types";
import { timelineLocationBoxTopY } from "./metrics";
import { isPartLocationRun } from "../LocationRun/anchor";
import {
  branchIdForPartRun,
  partRunPhase,
} from "../../rail/PartRunPhase/phase";
import { branchForSiteRun, forkTravelerFollowActive } from "../LocationRun/siteAnchor";
import {
  locationRunAnchorX,
  partLocationRunAnchorX,
} from "./placeRunAnchor";

function laneForRun(run: LocationRun, rail?: RailLayout): number {
  if (run.lane !== undefined) {
    return run.lane;
  }
  if (rail === undefined) {
    return 0;
  }
  const partBranch = isPartLocationRun(run) ? branchIdForPartRun(run) : null;
  const branchId = partBranch ?? run.runId;
  const branch = rail.branches.find((item) => item.id === branchId)
    ?? branchForSiteRun(run, rail);
  return branch?.lane ?? 0;
}

function locationRunZIndex(_run: LocationRun, order: number): number {
  return order;
}

export function placeLocationRuns(
  runs: LocationRun[],
  playheadMs: number,
  viewportWidth: number,
  totalDurationMs: number,
  includePastRuns: boolean,
  rail?: RailLayout,
): LocationBoxPlacement[] {
  const result: LocationBoxPlacement[] = [];

  for (let i = 0; i < runs.length; i++) {
    const run = runs[i];
    if (
      !includePastRuns
      && playheadMs >= run.endMs
      && (rail === undefined || !forkTravelerFollowActive(rail, run, playheadMs))
    ) {
      continue;
    }
    const lane = laneForRun(run, rail);
    const partPhase = rail !== undefined && isPartLocationRun(run)
      ? partRunPhase(rail, run, playheadMs)
      : undefined;
    const isActive = partPhase !== undefined
      ? partPhase.kind === "active"
      : playheadMs >= run.startMs && playheadMs < run.endMs;
    const anchorX = partPhase !== undefined
      ? partLocationRunAnchorX(
        run,
        partPhase,
        playheadMs,
        viewportWidth,
        totalDurationMs,
        rail,
      )
      : locationRunAnchorX(
        run,
        isActive,
        playheadMs,
        viewportWidth,
        totalDurationMs,
        rail,
      );
    result.push({
      runId: run.runId,
      anchorX,
      topY: timelineLocationBoxTopY(lane, rail?.branches.find((branch) => (
        branch.lane === lane && branch.startMs <= run.startMs && run.startMs < branch.endMs
      ))?.laneOffsets),
      above: false,
      paletteIndex: i,
      zIndex: locationRunZIndex(run, i),
    });
  }

  return result;
}
